<div class="container-fluid" [ngClass]="{'p-0': mobileMode, 'h-100': mobileMode}" style="position: relative"
  [style.background-color]="clozeTestStyleModel.siteBackground">
  <div class="d-flex justify-content-center" [ngClass]="{'h-100': mobileMode}">
    <div class="card" [ngClass]="{'container-fluid': mobileMode, 'p-0': mobileMode}" style="min-height: 570px;"
      [style.background-color]="clozeTestStyleModel.exerciseBackground"
      [ngStyle]="{'border': mobileMode ? '0px' : '1px solid ' + clozeTestStyleModel.frameColor, 'border-radius': mobileMode? '0px' : '0.25rem', 'width': mobileMode? '' : '720px'}">
      <!-- mobile exercise header -->
      <div *ngIf="mobileMode" class="onset-indicator">
        <img style="max-width: 100px;float: right;" [src]="cTestLogo">
      </div>
      <!-- mobile exercise indicator end -->
      <div class="card-body" [ngClass]="{'card-mobile': mobileMode }" [style.font-family]="clozeTestStyleModel.font"
        [style.font-size]="clozeTestStyleModel.fontSize">
        <img *ngIf="clozeTestStyleModel.displayLogo && !mobileMode" class="floating-logo" [src]="cTestLogo">
        <div class="row" *ngIf="clozeTestStyleModel.displayLogo && mobileMode">
        </div>
        <h5 *ngIf="!mobileMode" class="card-title text-center font-weight-bold"
          [innerHTML]="'GAST-ONSET-NG.INTRODUCTION.TITLE' | translate"></h5>
          <h5 *ngIf="mobileMode" class="card-title text-center font-weight-bold"
          [innerHTML]="'GAST-ONSET-NG.MOBILE.INTRODUCTION.TITLE' | translate"></h5>
        <h6 *ngIf="!mobileMode" class="card-subtitle mb-2 text-muted text-center"
          [innerHTML]="'GAST-ONSET-NG.INTRODUCTION.SUBTITLE' | translate"></h6>
        <div *ngIf="mobileMode">
          <div class="mt-4 instruction-container">
            <img class="instruction-icon" src="onset-assets/img/onSET_Text.svg">
            <span class="instruction-text">{{ 'GAST-ONSET-NG.MOBILE.INTRODUCTION.INSTRUCTION_1' | translate }}</span>
          </div>
          <div class="mt-4 instruction-container">
            <img class="instruction-icon" src="onset-assets/img/onSET_Zeit.svg">
            <span class="instruction-text">{{ 'GAST-ONSET-NG.MOBILE.INTRODUCTION.INSTRUCTION_2' | translate }}</span>
          </div>
          <div class="mt-4 instruction-container">
            <img class="instruction-icon" src="onset-assets/img/onSET_Zeit_fertig.svg">
            <span class="instruction-text">{{ 'GAST-ONSET-NG.MOBILE.INTRODUCTION.INSTRUCTION_3' | translate }}
            </span>
          </div>
          <div class="mt-4 instruction-container">
            <img class="instruction-icon" src="onset-assets/img/onSET_Text_beenden.svg">
            <span class="instruction-text">{{ 'GAST-ONSET-NG.MOBILE.INTRODUCTION.INSTRUCTION_4' | translate }}</span>
          </div>
        </div>
        <br>
        <p class="card-text" *ngIf="!mobileMode" [innerHTML]="'GAST-ONSET-NG.INTRODUCTION.CONTENT' | translate"></p>
        <div class="text-center">
          <button *ngIf="!mobileMode" class="btn" style="font-size: smaller;"
            [style.background-color]="cTestButtonColor"
            (click)="toggleStartTest()">{{ 'GAST-ONSET-NG.MOBILE.INTRODUCTION.START_TEST' | translate }}</button>
          <p style="text-align: start;" *ngIf="mobileMode">
            {{ 'GAST-ONSET-NG.MOBILE.INTRODUCTION.START_EXAMPLE_INFO' | translate }}
          </p>
          <button *ngIf="mobileMode" class="btn" style="font-size: smaller;" [style.background-color]="cTestButtonColor"
            (click)="toggleStartTestExample()">{{ 'GAST-ONSET-NG.MOBILE.INTRODUCTION.START_EXAMPLE' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
